'use strict'

/**
 * Render a selection template with custom content
 * Used for Select2 and other select components
 */
export function renderSelectionTemplate(data, childrenCallback) {
  try {
    const span = document.createElement('span')
    const content = childrenCallback(data)

    if (content) {
      if (Array.isArray(content)) {
        content.forEach((node) => span.appendChild(node))
      } else {
        span.appendChild(content)
      }
    }

    return span
  } catch (e) {
    return null
  }
}

/**
 * Extract ID from option object or value
 */
export function extractIdFromOption(item) {
  if (!item || typeof item !== 'object') {
    return String(item || '')
  }
  return String(item.id ?? item.value ?? '')
}

/**
 * Normalize initial value for select2 initialization
 */
export function normalizeInitialValue(val) {
  if (val === null || val === undefined) {
    return null
  }

  if (Array.isArray(val)) {
    return val.map(extractIdFromOption).filter((v) => v !== '')
  }

  if (typeof val === 'object') {
    return extractIdFromOption(val)
  }

  return String(val)
}
